import { StyleSheet, View } from 'react-native';

import {
  IconRedeem,
  IconVisibility,
  IconVisibilityOff,
  Pressable,
  Text,
  XStack,
  tokens,
} from '@fhs/ui';

import { formatCardNumber, maskCardNumber } from '../utils/helpers';

export type GiftCardNumberProps = {
  lastDigits: string;
  cardNumber?: string;
  pin?: string;
  isLoading: boolean;
  isRedacted: boolean;
  onPress: () => void;
};

const MASKED_PIN = '••••';

export function GiftCardNumber(props: GiftCardNumberProps) {
  const maskedCardNumber = maskCardNumber({ lastDigits: props.lastDigits });
  const formattedCardNumber = formatCardNumber(props.cardNumber ?? '');
  const displayPin = props.isRedacted ? MASKED_PIN : props.pin;

  return (
    <Pressable style={styles.container} onPress={props.onPress} disabled={props.isLoading}>
      <XStack style={styles.contentWrapper}>
        <View style={styles.iconCircle}>
          <IconRedeem size={24} color={tokens.colors.$houseDark} />
        </View>
        <View style={styles.textWrapper}>
          <XStack>
            <Text>CARD #: </Text>
            {props.isLoading ? (
              <View style={styles.skeleton} />
            ) : (
              <Text weight={'semibold'}>
                {props.isRedacted ? maskedCardNumber : formattedCardNumber}
              </Text>
            )}
          </XStack>
          <XStack>
            <Text>PIN: </Text>
            {props.isLoading ? (
              <View style={styles.pinSkeleton} />
            ) : (
              <Text weight={'semibold'}>{displayPin}</Text>
            )}
          </XStack>
        </View>
        <View style={styles.iconVisibilityWrapper}>
          {props.isRedacted ? (
            <IconVisibility size={24} color={tokens.colors.$houseDark} />
          ) : (
            <IconVisibilityOff size={24} color={tokens.colors.$houseDark} />
          )}
        </View>
      </XStack>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 16,
    borderBottomRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    borderTopWidth: 0,
  },
  contentWrapper: {
    gap: 12,
    alignItems: 'center',
  },
  textWrapper: {
    flex: 1,
    gap: 2,
  },
  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 100,
    gap: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$blackOpacity04,
  },
  iconVisibilityWrapper: {
    marginLeft: 'auto',
  },
  skeleton: {
    minWidth: 150,
    borderRadius: 4,
    backgroundColor: tokens.colors.$blackOpacity10,
  },
  pinSkeleton: {
    minWidth: 40,
    borderRadius: 4,
    backgroundColor: tokens.colors.$blackOpacity10,
  },
});
